module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Align-auto-9f7f2b68566ad9835580ce748d23381d.svg";